import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import useToast from "hooks/useToast";
import React, { MouseEvent } from "react";
import styles from "./styles.module.scss";

export const DELETE_CAMPAIGN_IMAGE = gql`
  mutation deleteCampaignImage($campaignListingUUID: UUID!, $imageUUID: UUID!) {
    deleteCampaignListingImages(
      input: {
        campaignListingUuid: $campaignListingUUID
        imageUuids: [$imageUUID]
      }
    ) {
      id
      externalId
      userImages: images2 {
        nodes {
          id
          url
        }
      }
    }
  }
`;

type Props = {
  imageUUID: string;
  campaignListingUUID: string;
  beforeMutationCallback?: Function;
};

const DeleteCampaignImageButton = ({
  imageUUID,
  campaignListingUUID,
  beforeMutationCallback = () => {},
}: Props) => {
  const [deleteCampaignListingImages, { loading }] = useMutation(
    DELETE_CAMPAIGN_IMAGE
  );
  const { showToast } = useToast();
  const onClick = async (evt: MouseEvent) => {
    evt.stopPropagation();
    // eslint-disable-next-line no-restricted-globals, no-alert
    if (confirm("Do you want to remove this image?")) {
      try {
        beforeMutationCallback();
        await deleteCampaignListingImages({
          variables: {
            imageUUID,
            campaignListingUUID,
          },
        });
        showToast("Image was successfully deleted");
      } catch (err) {
        // Airbrake can go here
        showToast("Image could not be deleted.");
      }
    }
  };

  return (
    <button
      type="button"
      data-qa="delete-campaign-image"
      disabled={loading}
      onClick={onClick}
      className={styles.iconButton}
    >
      <i className="icon icon-trashcan" />
    </button>
  );
};

export default DeleteCampaignImageButton;
